module.exports = __webpack_public_path__ + "ccc069c8a9f2d002d8332fd543e0bbc3.svg";